var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlorinSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 40C384 44.406 380.422 48 376 48H329.328C301.016 48 275.594 64.344 266.094 88.625L203.721 248H344C348.422 248 352 251.594 352 256S348.422 264 344 264H197.459L132.813 429.188C120.922 459.594 89.516 480 54.672 480H8C3.578 480 0 476.406 0 472S3.578 464 8 464H54.672C82.984 464 108.406 447.656 117.906 423.375L180.279 264H40C35.578 264 32 260.406 32 256S35.578 248 40 248H186.541L251.187 82.812C263.078 52.406 294.484 32 329.328 32H376C380.422 32 384 35.594 384 40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorinSign);
export default __webpack_public_path__ + "static/media/florin-sign.84a74e003f027382c68b3f898ded6cf1.svg";
export { ForwardRef as ReactComponent };